<template>
  <div class="order-card">
    <div class="order-title" style="position: relative;">
      <span>{{$t('ORDER_NO')}}:  {{ order.orderNo }}</span>
      <span class="order-create-at">
        {{$t('BUY_AT')}}:  <time-formatter :time="order.createAt" format="YYYY-MM-DD HH:mm"/>
      </span>
      <span style="margin: 0 10px">
        <span style="margin: 0 2px;">
          TO:&nbsp;&nbsp;{{ order.name }}
        </span>
        <span style="margin: 0 2px;">
          <i class="fa fa-mobile" aria-hidden="true"></i>&nbsp;{{ order.mobile }}</span>
        <span style="margin: 0 2px;">
          <i class="fa fa-location-arrow" aria-hidden="true"></i>
          &nbsp;{{ order.province }}/{{ order.city }}/{{ order.district }}
        </span>
        <span style="margin: 0 2px;">
          &nbsp;{{ order.address }}
        </span>
         <span style="margin: 0 2px;">
          &nbsp;<a-icon type="safety" />{{ order.zipCode }}
        </span>
      </span>
      <span style="position: relative;z-index: 1;float: right">
        <a-button
          @click="viewOrderRecords(order.id)"
          type="link"
        > {{ $t('ORDER_DETAIL') || '详情' }}
      </a-button>
     </span>
    </div>
    <div
        class="order-detail"
        :gutter="20"
        :key="detail.id"
        v-for="(detail,index) in order.oldOrderDetail">
      <div class="sku-image">
        <img
          style="width: 60px; height: 60px; border: 1px dashed #eeeeee;"
          :src="detail.coverPath"
          :preview-src-list="[detail.coverPath]"/>
      </div>

      <div style="margin-left:80px ">
        <a-row>
          <a-col :span="6">
            <div class="sku-info">
               <div >{{ detail.name }}</div>
              <div class="sku-info-name primary-info">{{ detail.nameEn }}</div>
              <div class="sku-info-tag">
                <a-tag  effect="dark"> {{ detail.specs }}</a-tag>
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="buy-info">
              <div class="buy-info-price primary-info">{{ detail.price }}</div>
              <div
                class="buy-info-quality second-info"
                style="color: #ff0000">&times;{{ detail.quantity }}
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div :class="`status primary-info ${order.status}`" v-if="index===0">
              <a-tag color="pink" v-if="order.status === 'UN_PAID'">
                {{ $t('UN_PAID') }}
              </a-tag>
              <a-tag color="red" v-if="order.status === 'UN_SHIPPED'">
                {{ $t('UN_SHIPPED') }}
              </a-tag>
              <a-tag color="orange" v-if="order.status === 'TO_BE_SHIPPED'">
                {{ $t('TO_BE_SHIPPED') }}
              </a-tag>
              <a-tag color="green" v-if="order.status === 'TRANSACTION_COMPLETED'">
                {{ $t('TRANSACTION_COMPLETED') }}
              </a-tag>
              <a-tag color="cyan" v-if="order.status === 'APPLY_REFUND'">
                {{ $t('APPLY_REFUND') }}
              </a-tag>
              <a-tag color="blue" v-if="order.status === 'REFUND'">
                {{ $t('REFUND') }}
              </a-tag>
              <a-tag color="purple" v-if="order.status === 'REFUND_COMPLETED'">
                {{ $t('REFUND_COMPLETED') }}
              </a-tag>
              <a-tag color="#6f6f6f" v-if="order.status === 'CANCEL'">
                {{ $t('CANCEL') }}
              </a-tag>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="amount" v-if="index===0">
              <div class="total-amount">总金额: ￥{{ order.totalAmount }}</div>
              <!-- <div class="primary-info">金额:￥{{ order.amount }}</div> -->
              <div class="second-info">运费:￥{{ order.postage }}</div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="operation" v-if="index===0 && editable">
              <a-button
                type="link"
                @click="editOrderExpress(order.id)"
                v-if="order.status === 'UN_SHIPPED'">
                {{ $t('SHIPPED_ORDER') || '发货' }}
              </a-button>
              <a-button
                type="link"
                @click="editOrderStatus(order.id)"
                v-if="order.status === 'UN_PAID' && order.isSpecialSettlement === 'YES'">
                {{ $t('UPDATE_ORDER_STATUS') || '修改订单状态' }}
              </a-button>
              <a-button
                type="link"
                @click="completedOrder(order.id)"
                v-if="order.status === 'TO_BE_SHIPPED'">
                {{ $t('COMPLETE_ORDER') || '交易成功' }}
              </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import TimeFormatter from './TimeFormatter.vue';

export default {
  name: 'OrderCard',
  components: { TimeFormatter },
  props: {
    order: Object,
    shippedOrder: Function,
    completedOrder: Function,
    refundOrder: Function,
    syncWDT: Function,
    editOrderExpress: Function,
    editOrderStatus: Function,
    viewOrderRecords: Function,
    exportInvoice: Function,
    editable: Boolean,
  },
  data() {
    return {
      showDetail: false,
      hasLoadingDetail: false,
    };
  },

};
</script>

<style scoped>
.order-card {
  font-size: 14px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
}

.order-title {
  padding: 5px;
  line-height: 38px;
}
.total-amount {
  line-height: 40px;
}
.primary-info {
  line-height: 30px;
  color: #b4b4b4;
}

.sku-image {
  margin-top: 5px;
  float: left;
  width: 80px;
}

.second-info {
  line-height: 30px;
  color: #b4b4b4;
}

.order-create-at {
  padding-left: 10px;
}

.order-detail {
  margin-bottom: 5px;
}

.order-order-no {
  font-weight: 700;
  padding: 0 20px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.status.UN_SHIPPED, .status.TO_BE_SHIPPED {
  color: rgb(242, 165, 26);
}

.status.TRANSACTION_COMPLETED {
  color: rgb(46, 182, 125);
}

.status.CANCEL, .status.UN_PAID {
  color: rgb(224, 30, 91);
}
</style>
